import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import { remCalc } from '@monorepo/shared/src/util/style-util';

type IconBadgeProps = {
  icon: IconDefinition;
  color: string | undefined;
};

const IconBadge: React.FC<IconBadgeProps> = ({ icon, color, children }) => {
  return (
    <Box display="flex" flexDirection="column">
      <FontAwesomeIcon icon={icon} style={{ fontSize: remCalc(20) }} color={color} />
      {children}
    </Box>
  );
};

export default IconBadge;
